import React, { useRef, useEffect } from 'react';
import Card from '@material-ui/core/Card';
import ReactEcharts from 'echarts-for-react';

const ChartCard = props => {
    return (
        <Card style={{paddingTop:'10px', paddingBottom: '4px'}}>
            {
                props.eChartGet > 0 ?
                <ReactEcharts option={props.myOptions} style={{ marginLeft: '5px' }} /> :<div className='adt-insufficient-volume-data'>Insufficient volume data available for ADT calculation at this station.</div>
            }
          </Card>
      )
}
export default ChartCard;